import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getTeamInvitation, acceptTeamInvitation } from '../services/api';

const TeamInvitation = () => {
  const { invitationId } = useParams();
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true); setInvitation(null); setAccepted(false); setError('');
    getTeamInvitation(invitationId).then((response) => {
      if (!active) return;
      setInvitation(response.invitation);
      setAccepted(response.invitation.status === 'accepted');
    }).catch((err) => {
      if (active) setError(err.message || 'Impossible de charger cette invitation.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [invitationId]);

  const accept = async () => {
    setBusy(true);
    setError('');
    try {
      await acceptTeamInvitation(invitationId);
      setAccepted(true);
    } catch (err) {
      setError(err.message || "Impossible d'accepter cette invitation.");
    } finally { setBusy(false); }
  };

  const available = invitation?.status === 'pending' && new Date(invitation.expires_at) > new Date();
  return (
    <div className="container" style={{ maxWidth: 650, padding: '3rem 1rem' }}>
      <h1>Invitation à rejoindre une équipe</h1>
      {loading && <p>Chargement...</p>}
      {error && <p className="error-message" role="alert">{error}</p>}
      {invitation && <p>{invitation.manager.name} vous invite à rejoindre son équipe de photographes.</p>}
      {accepted ? <p className="success-message">Vous avez rejoint cette équipe.</p> : available ? (
        <>
          <p>En acceptant, vous autorisez cet organisateur à vous créditer sur les photos de ses événements.</p>
          <button className="btn-primary" disabled={busy} onClick={accept}>
            {busy ? 'Acceptation...' : "Accepter et rejoindre l'équipe"}
          </button>
        </>
      ) : invitation && <p>Cette invitation a expiré ou a été annulée. Demandez une nouvelle invitation à l'organisateur.</p>}
      <p><Link to="/dashboard">Retour à mon compte</Link></p>
    </div>
  );
};

export default TeamInvitation;
